module.exports = __webpack_public_path__ + "static/charlies-poppies-70a063639ec9059bb1f97dd862258699.svg";